export const defaultRouteConfig = {
  exact: true,
  requireAuthentication: false,
  displayAppBar: true,
  displayFooter: true,
  isDarkMode: false,
}
